namespace SorAraBul.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<number> {
    }
}

